import { navWidth } from "components/LeftMenu/LeftMenu.styles";
import { PANEL_WIDTH } from "containers/RightPanel/RightPanel.styles";
import { PageWrapper } from "layouts/Layout.styles";
import { fadeInLeft, fadeOutRight } from "react-animations";
import { Container } from "react-grid-system";
import styled from "styled-components";
import { Button } from "../../components/Button";
import { Icon } from "../../components/Icon";
import PreLoader from "../../components/PreLoader/PreLoader";
import { StorageButton } from "../../styles/parcelsStyles";

export const Wrapper = styled(PageWrapper)<{ $isPanelOpened: boolean }>`
  position: absolute;
  width: 100%;
  animation: none;
  transition: padding-right 0.2s ease-in-out;

  /* Exactly the panel's width: the rows run up to the panel's edge, so its
     shadow falls across them instead of on a strip of bare ground. */
  ${({ $isPanelOpened }) =>
    $isPanelOpened && `padding-right: ${PANEL_WIDTH};`}

  ${({ theme }) => theme.xs`
    padding-right: 0;
  `}

  &.page-enter {
    animation: ${fadeInLeft} 0.22s ease;
  }

  &.page-exit {
    animation: ${fadeOutRight} 0.22s ease;
  }
`;

export const StyledGrid = styled(Container)`
  position: relative;
`;

export const StorageHeading = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;

export const SelectAllSwitchWrapper = styled.div`
  margin-right: 8px;
  transform: translateY(4px);
`;

export const ButtonsWrapper = styled.div`
  width: 100%;
  height: 86px;
`;

export const Buttons = styled.div<{ $singleRow?: boolean }>`
  padding: 20px 15px;
  background-color: ${({ theme }) => theme.surface};
  position: fixed;
  display: flex;
  align-items: center;
  left: ${navWidth};
  bottom: 0;
  width: 100%;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    height: 20px;
    background: linear-gradient(
      to top,
      ${({ theme }) => theme.surface},
      transparent
    );
    pointer-events: none;
  }

  & > div {
    display: flex;
    margin: 0 10px;
  }

  & > button {
    margin: 0 10px;
    min-width: 150px;
  }

  ${(props) => props.theme.sm`
    left: 0;

    &::before {
      left: 0;
    }
  `}

  ${(props) => props.theme.xs`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;

    button {
      margin: 5px;
    }
  `}

  ${(props) =>
    props.$singleRow &&
    props.theme.xs`
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      gap: 10px;

      & > div {
        margin: 0;
        min-width: 0;
        flex: 1 1 auto;
      }

      & > button {
        margin: 0;
        min-width: auto;
      }
    `}
`;

/*
 * Buttons is fixed at left: navWidth with width: 100%, so its box overflows
 * the viewport by navWidth on the right; the open right panel covers another
 * PANEL_WIDTH. Compensate both so the toggle sits at the visible right corner.
 */
export const GuideToggleButton = styled(StorageButton)<{
  $isPanelOpened: boolean;
}>`
  && {
    min-width: auto;
    margin-left: auto;
    margin-right: calc(
      ${navWidth} + 20px +
        ${({ $isPanelOpened }) => ($isPanelOpened ? PANEL_WIDTH : "0px")}
    );
    transition: margin-right 0.2s ease-in-out;
  }

  ${(props) => props.theme.sm`
    && {
      margin-right: 20px;
    }
  `}
`;

export const ButtonLineWrapper = styled.div`
  display: flex;
  gap: 10px;

  & > button {
    min-width: 150px;
  }

  ${(props) => props.theme.xs`
    & > button {
      min-width: auto;
      flex: 1 1 auto;
    }
  `}
`;

export const TopLineWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const StorageBranchesSpinnerWrapper = styled.div`
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
`;

export const StorageBranchesSpinner = styled(PreLoader)`
  position: absolute;
`;

export const MenuIcon = styled(Icon)`
  height: 15px;
  width: 9px;
  margin-left: 10px;
  background-color: ${({ theme }) => theme.black};
  font-size: 20px;
`;

export const DropdownMenuTriggerButton = styled(Button)`
  display: flex;
  align-items: center;
  padding-right: 16px;
`;
